import AppComponent from '../../mixins/app-component'

import * as Random from '../../utils/Random'

import AppIcon from '../app-icon'

export default
{
    name: 'app-token-allocation-graphic',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        data: { type: Array, default: [] }
    },

    computed: {
        dataAmplified() {
            const moreItems = []
            for (let i = 0; i < this.data.length * 3; i += 1) {
                moreItems.push({
                    label: '',
                    percent: Random.randomBetween(0.5, 6),
                    id: i + this.data.length,
                    color: '#DFE7FE'
                })
            }

            return this.data.concat(moreItems)
        }
    },

    created() {
        this.positionTop = null

        this.canvas = null
        this.context = null

        this.width = null
        this.height = null

        this.items = []
        this.circleBaseRadius = null
        this.offsetBetweenItems = 5

        // Dragging
        this.mouse = {
            x: null,
            y: null,
            click: {
                x: null,
                y: null
            }
        }
        this.isDragging = false
        this.draggingItem = null

        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$on('window:resize', this.resize)
    },

    mounted() {
        this.positionTop = this.$el.getBoundingClientRect().top

        this.canvas = document.querySelector('.js-token-allocation-canvas')
        this.context = this.canvas.getContext('2d')

        this.resize()
        this.createItems()

        this.$el.addEventListener('mousedown', this.onMousedown)
        this.$el.addEventListener('mousemove', this.onMousemove)
        this.$el.addEventListener('mouseleave', this.onMouseleave)
        this.$el.addEventListener('mouseup', this.onMouseup)

        this.$el.addEventListener('touchstart', this.onMousedown)
        this.$el.addEventListener('touchmove', this.onMousemove)
        this.$el.addEventListener('touchleave', this.onMouseleave)
        this.$el.addEventListener('touchcancel', this.onMouseleave)
        this.$el.addEventListener('touchend', this.onMouseup)
    },

    destroyed() {
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$off('window:resize', this.resize)

        this.$el.removeEventListener('mousedown', this.onMousedown)
        this.$el.removeEventListener('mousemove', this.onMousemove)
        this.$el.removeEventListener('mouseleave', this.onMouseleave)
        this.$el.removeEventListener('mouseup', this.onMouseup)

        this.$el.removeEventListener('touchstart', this.onMousedown)
        this.$el.removeEventListener('touchmove', this.onMousemove)
        this.$el.removeEventListener('touchleave', this.onMouseleave)
        this.$el.removeEventListener('touchcancel', this.onMouseleave)
        this.$el.removeEventListener('touchend', this.onMouseup)
    },

    methods: {
        /* Mouse events */
        onMousedown(event) {
            if (event.clientX) {
                this.mouse.click.x = event.clientX - this.$el.getBoundingClientRect().left
                this.mouse.click.y = event.clientY - this.$el.getBoundingClientRect().top
                this.mouse.x = event.clientX - this.$el.getBoundingClientRect().left
                this.mouse.y = event.clientY - this.$el.getBoundingClientRect().top
            } else if (event.touches[0]) {
                this.mouse.click.x = event.touches[0].clientX - this.$el.getBoundingClientRect().left
                this.mouse.click.y = event.touches[0].clientY - this.$el.getBoundingClientRect().top
                this.mouse.x = event.touches[0].clientX - this.$el.getBoundingClientRect().left
                this.mouse.y = event.touches[0].clientY - this.$el.getBoundingClientRect().top
            } else {
                return
            }

            this.items.forEach(item => {
                if (!this.draggingItem) {
                    const dx = item.target.x - this.mouse.click.x
                    const dy = item.target.y - this.mouse.click.y
                    const d = Math.sqrt((dx * dx) + (dy * dy))

                    if (d < item.radius) {
                        document.body.classList.add('u-cursor-pointer')
                        this.draggingItem = item
                        this.draggingItem.isDragging = true
                        this.draggingItem.position.dx = dx
                        this.draggingItem.position.dy = dy
                    }
                }
            })

            this.toggleIsDragging(true)
        },

        onMouseup() {
            this.mouse.click.x = null
            this.mouse.click.y = null

            this.toggleIsDragging(false)

            document.body.classList.remove('u-cursor-pointer')

            if (this.draggingItem) this.draggingItem.isDragging = false
            this.draggingItem = null
        },

        onMouseleave() {
            this.mouse.click.x = null
            this.mouse.click.y = null

            this.toggleIsDragging(false)

            document.body.classList.remove('u-cursor-pointer')

            if (this.draggingItem) this.draggingItem.isDragging = false
            this.draggingItem = null
        },

        onMousemove(event) {
            if (event.clientX) {
                this.mouse.x = event.clientX - this.$el.getBoundingClientRect().left
                this.mouse.y = event.clientY - this.$el.getBoundingClientRect().top
            } else if (event.touches[0]) {
                this.mouse.x = event.touches[0].clientX - this.$el.getBoundingClientRect().left
                this.mouse.y = event.touches[0].clientY - this.$el.getBoundingClientRect().top
            } else {
                return
            }

            let rolloverItem = false

            // Chek if :hover an item
            this.items.forEach(item => {
                const dx = item.target.x - this.mouse.x
                const dy = item.target.y - this.mouse.y
                const d = Math.sqrt((dx * dx) + (dy * dy))

                if (d < item.radius) {
                    event.preventDefault()
                    rolloverItem = true
                }
            })

            if (rolloverItem) {
                document.body.classList.add('u-cursor-pointer')
            } else {
                document.body.classList.remove('u-cursor-pointer')
            }
        },
        /* ***** */

        /* Toggle */
        toggleIsDragging(isDragging = !this.isDragging) {
            this.isDragging = isDragging
        },
        /* ***** */

        /* onEnterFrame */
        onEnterFrame() {
            const onScreen = this.positionTop && this.positionTop - this.$root.currScrollTop <= this.$root.height && this.positionTop + this.$el.offsetHeight >= this.$root.currScrollTop
            
            if (this.items.length > 0 && (onScreen || this.$root.isIOS)) {
                this.updateItems()
                this.drawItems()
            }
        },
        /* ***** */

        resize() {
            const width = document.querySelector('.js-token-allocation-canvas-container').offsetWidth
            const height = document.querySelector('.js-token-allocation-canvas-container').offsetHeight
            
            if (width !== this.width || height !== this.height) {
                this.width = width
                this.height = height
                
                this.canvas.width = this.width
                this.canvas.height = this.height

                this.circleBaseRadius = this.width > this.height ? this.height / 150 : this.width / 150

                this.items.forEach(item => {
                    let radius = item.percent * this.circleBaseRadius
                    if (radius < 34 && item.label) {
                        radius = 34
                    }
                    item.radius = item.percent * this.circleBaseRadius
                })
            }
        },

        createItems() {
            // Reset items array
            this.items.length = 0
            this.items = []
            
            const $datas = this.$el.querySelectorAll('.js-token-allocation-canvas-data')

            // const itemOverlapsOther = false
            this.dataAmplified.forEach(data => {
                let radius = data.percent * this.circleBaseRadius
                if (radius < 34 && data.label) {
                    radius = 34
                }
                const item = {
                    $data: $datas[data.id],
                    label: data.label,
                    percent: data.percent,
                    id: data.id,
                    radius,
                    color: data.color || 'white',
                    target: {
                        x: Random.randomBetween((this.circleBaseRadius * data.percent) + this.offsetBetweenItems, this.width - (this.circleBaseRadius * data.percent) - this.offsetBetweenItems),
                        y: Random.randomBetween((this.circleBaseRadius * data.percent) + this.offsetBetweenItems, this.height - (this.circleBaseRadius * data.percent) - this.offsetBetweenItems)
                    },
                    position: {
                        x: 0,
                        y: 0,
                        dx: null,
                        dy: null
                    },
                    mass: data.percent * this.circleBaseRadius
                }
                
                item.position.x = item.target.x
                item.position.y = item.target.y

                // if (!itemOverlapsOther) {
                // console.log(item.$data)
                this.items.push(item)
                // }
            })
            

            // while (this.items.length !== this.dataAmplified.length) {
            //     this.createItems()
            // }

            this.drawItems()
        },

        updateItems() {
            this.items.forEach(item1 => {
                this.items.forEach(item2 => {
                    let dx = item2.target.x - item1.target.x + this.offsetBetweenItems
                    let dy = item2.target.y - item1.target.y + this.offsetBetweenItems
                    const r = item1.radius + item2.radius
                    let d = (dx * dx) + (dy * dy)

                    if (d < r * r) {
                        d = Math.sqrt(d)
                        dx /= d
                        dy /= d
                        d = (r - d) * 0.5
                        dx *= d
                        dy *= d

                        if (!item1.isDragging) {
                            item1.target.x -= dx
                            item1.target.y -= dy
                        }

                        if (!item2.isDragging) {
                            item2.target.x += dx
                            item2.target.y += dy
                        }
                    }
                })
            })

            if (this.isDragging && this.draggingItem) {
                this.items.forEach(item => {
                    if (this.draggingItem === item) {
                        item.target.x = this.mouse.x + item.position.dx
                        item.target.y = this.mouse.y + item.position.dy
                    }
                })
            }

            // center attraction
            this.items.forEach(item => {
                const dx = item.target.x - (this.width / 12 * 8 / 2)
                const dy = item.target.y - (this.height / 3)
                const f = 1 / item.radius
                
                item.target.x -= dx * 1 * f
                item.target.y -= dy * 1 * f
            })

            this.items.forEach(item => {
                if (item.target.x <= item.radius) {
                    item.target.x = item.radius
                }

                if (item.target.x >= (this.width - item.radius)) {
                    item.target.x = this.width - item.radius
                }

                if (item.target.y <= item.radius) {
                    item.target.y = item.radius
                }

                if (item.target.y >= (this.height - item.radius)) {
                    item.target.y = this.height - item.radius
                }
            })
        },
        
        drawItems() {
            // Update values and test if needs update
            let needsUpdate = false

            this.items.forEach((item) => {
                item.target.x = Math.round(item.target.x * 10) / 10
                item.target.y = Math.round(item.target.y * 10) / 10
                
                if (item.target.x !== item.position.x || item.target.y !== item.position.y) {
                    item.position.x = item.target.x
                    item.position.y = item.target.y
                    
                    needsUpdate = true
                }
            })

            // Needs update
            if (needsUpdate) {
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            
                // Draw each item
                this.items.forEach((item, index) => {
                    this.context.beginPath()
                    this.context.arc(item.position.x, item.position.y, item.radius, 0, 2 * Math.PI, false)
                    this.context.fillStyle = item.color
                    this.context.fill()
                    this.context.closePath()

                    if (index < this.data.length) {
                        item.$data.style.transform = `translateX(${item.position.x}px) translateX(-50%) translateY(${item.position.y}px) translateY(-50%) translateY(-2px) translateZ(0)`
                    }
                })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-token-allocation-graphic/script.js